import type { S2CEvents } from '@sk/shared';

/** Только участник получает личный сигнал; общий журнал альянса обновляется отдельно. */
export function isPersonalBattleReport(
  userId: string | undefined,
  event: S2CEvents['battle:report'],
): boolean {
  return !!userId && (event.attackerId === userId || event.defenderId === userId);
}
